import React from "react";

import "./style.css";
import URL from "../../config/api";

function EmotionsContentItem(data) {
  return (
    <div
      className={`mt-3 bg-${"white"}`}
      id="contentItemCard"
      onClick={null}
      ref={null}
    >
      {data.data.photo ? (
        <div className="position-relative" id="contentImg">
          <div id="contentEmotion">
            <img
              src={URL.img + data.data.last_emotion_url}
              className="rounded-circle"
              id="contentEmotionItem"
            />
          </div>
          <img
            src={URL.img + data.data.photo}
            className="rounded-circle"
            id="contentIcon"
          />
        </div>
      ) : (
        <div className="position-relative" id="contentImg">
          <div id="contentEmotion">
            <img
              src={URL.img + data.data.last_emotion_url}
              className="rounded-circle"
              id="contentEmotionItem"
            />
          </div>
          <i className="fa fa-user text-gray" id="contentIcon"></i>
        </div>
      )}
      <div className="p-3 pr-4 d-flex" id="contentItemFooter">
        <div
          id="contentTitle"
          title={data.data.name}
          style={{ lineHeight: "1rem" }}
        >
          {data.data.name}
        </div>
        <span
          id="contentRoom"
          title={data.data.school_name}
          style={{ lineHeight: "1rem", maxHeight: "2rem" }}
        >
          {data.data.school_name}
        </span>
      </div>
    </div>
  );
}

export default EmotionsContentItem;
